module.exports = __webpack_public_path__ + "img/code.4ed508a0.png";